
let initialState = {
    api: ''
};

const FFTPReducer = (state = initialState, action) => {
    return state;
}

export default FFTPReducer;